import { ExternalServiceHeaders } from '../api/integrations';

function convertHeadersToRequest(
	headersArray: { headerName: string; value: string }[],
): ExternalServiceHeaders {
	return headersArray.reduce((acc, header) => {
		acc[header.headerName] = header.value;
		return acc;
	}, {} as ExternalServiceHeaders);
}

export default convertHeadersToRequest;
